module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-aboutus"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content about-us"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("\n                    Fund Raisers, Ltd., a Boise-based, woman-owned company, was founded in 1987 and has since become\n                    the leader in engraved brick projects for donor recognition and fundraising.\n                    In 2016, after decades of working with community projects, professional sports teams,\n                    colleges and universities, we unveiled our Fund Raisers Sports division.\n                    While both\n                    "), _vm._m(1), _vm._v(" and\n                    "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/",
      "tag": "a"
    }
  }, [_c('strong', [_c('span', [_vm._v("Fund Raisers, Ltd.")])])]), _vm._v("\n                    offer tremendous revenue and fund raising benefits,\n                    Fund Raisers, Ltd. works with and supports the efforts of community organizations, such as schools,\n                    parks, churches, military services, etc.\n                ")], 1), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("\n                    As the premier provider of fund raising programs, our\n                    "), _c('router-link', {
    attrs: {
      "to": "/unmatched-quality"
    }
  }, [_vm._v("proprietary filler")]), _vm._v("\n                    has proven to be an industry game-changer,\n                    able to withstand any climate while retaining legibility. Our product quality is visible year after year,\n                    with our programs gracing the most iconic facilities in the U.S., Canada, and Mexico.\n                    Our product performs under high-traffic conditions at stadiums, schools, churches, parks,\n                    military venues, and other community gathering spaces.\n                ")], 1), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("\n                    Check out "), _c('router-link', {
    attrs: {
      "to": "/our-work"
    }
  }, [_vm._v("our portfolio")]), _vm._v("\n                    and see if you recognize any of these iconic locations!\n                ")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper aboutus"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                        PIONEERING ENGRAVED\n                        "), _c('br'), _vm._v("\n                        BRICK PROJECTS SINCE 1987\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("Uniting communities brick-by-brick.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://www.fundraiserssports.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('span', [_vm._v("Fund Raisers Sports")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ed98ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs.vue
// module id = WSCi
// module chunks = 1